import styled, { css } from 'styled-components';

export const FormBox = styled.div`
  width: 440px;
  height: 220px;
  padding: 20px;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      color: var(--cp-text);
    `}
`;

export const CommentBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0 20px 0;
  padding: 13px 0;
  width: 400px;
  height: 80px;
  padding: 10px 0;
  align-items: flex-start;
  border-bottom: solid 1px #8e8e8e;
  border-top: solid 1px #8e8e8e;
  /* input::placeholder {
    color: #cccccc;
  } */
`;

export const CommentFieldName = styled.p`
  color: #8f8f8f;
  font-size: 13px;
`;

export const CommentInput = styled.textarea`
  font-size: 15px;
  width: 270px;
  height: 60px;
  border: none;
  outline: none;
  resize: none;
  &::placeholder {
    color: #cccccc;
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-color: #393e44;
      color: #f0f0f0;
    `}
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      background-color: transparent;
      color: var(--cp-text);
    `}
`;
